import { Button } from "@/components/ui/button";
import { useKycLogout } from "./use-kyc-logout";

const KycUnderReview = () => {
  const logout = useKycLogout();

  return (
    <div className="mx-auto mt-6 flex w-full max-w-xl grow flex-col justify-center lg:mt-0">
      <div className="flex flex-col items-center text-center">
        <img
          src="/images/kyc-under-review.svg"
          alt=""
          className="size-28 lg:size-36"
        />
        <h1 className="mt-6 text-2xl font-semibold lg:text-3xl">
          Account under review
        </h1>
        <p className="mt-3 max-w-md text-sm lg:text-base">
          Your identity verification (KYC) has been submitted successfully and
          is currently under review.
        </p>

        <div className="mt-8 flex w-full items-center gap-4 rounded-md bg-[#f3eee4]/60 p-4 text-left">
          <img
            src="/images/kyc-under-review.svg"
            alt=""
            className="hidden size-20 shrink-0 sm:block"
          />
          <div>
            <h2 className="font-semibold">What happens next?</h2>
            <p className="mt-1 text-sm">
              We&apos;ll review your information and notify you once it&apos;s
              complete. This usually takes a few minutes to a few hours
              depending on our KYC provider.
            </p>
          </div>
        </div>

        <Button
          variant="outline"
          onClick={logout}
          className="border-auth-action text-auth-text mt-8 h-11 w-full rounded bg-transparent"
        >
          Logout
        </Button>
      </div>
    </div>
  );
};

export default KycUnderReview;
